
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersDay as ObiLightningRainShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-day.js';
 
 
 

 
 export const ObiLightningRainShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-day',
   elementClass: ObiLightningRainShowersDayElement,
   events: {
     
   }
  });
 
 